module.exports = __webpack_public_path__ + "img/6.54f42a46.jpg";